import { CommonUrls } from './constantEx';
import { API_BASE_URL, DATE_DISPLAY_FORMAT } from '../../startups/apiConfig';
import dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc' // import plugin

dayjs.extend(utc);

export const GetDateOnly = (dateTimeValue) => {
    return new Date(dateTimeValue.getYear(), dateTimeValue.getMonth(), dateTimeValue.getDate(), 0, 0, 0);
}

export const GetDateOnlyStringValue = (dateTimeValue) => {
    return dateTimeValue.format(DATE_DISPLAY_FORMAT)
}

export const UserLoginAPIUrl = () => API_BASE_URL + CommonUrls.UserLogin;

export const UserLoginSessionAPIUrl = () => API_BASE_URL + CommonUrls.UserLoginSession;

export const CompanyAPIUrl = (companyCode) => API_BASE_URL + CommonUrls.Company.replace('<code>', companyCode);

export const UserChangePasswordAPIUrl = (companyCode) => CompanyAPIUrl(companyCode) + CommonUrls.UserChangePassword;

export const GetGetReminderDataAPIUrl = (companyCode) => CompanyAPIUrl(companyCode) + CommonUrls.GetReminderData;

export const GetReligionAPIUrl = () => API_BASE_URL + CommonUrls.GetReligions;

export const GetServiceTypesAPIUrl = () => API_BASE_URL + CommonUrls.ServiceTypes;

export const DocumentAPIUrl = (companyCode, docId = 0) => {
    const tempDocUrl = CompanyAPIUrl(companyCode) + CommonUrls.Document;
    return tempDocUrl + (docId > 0 ? ('?doc_id=' + docId.toString()) : '').trim();
}

export const DownloadDocumentAPIUrl = (companyCode, docId) => {
    const tempDocUrl = CompanyAPIUrl(companyCode) + CommonUrls.Document + '/download?doc_id=';
    return tempDocUrl + docId.toString();
}

export const GetNurseSeachAPIUrl = (companyCode, searchText, showOnlyClosedServices = false) => {
    let tempUrl = CompanyAPIUrl(companyCode) + CommonUrls.NurseSeach;
    tempUrl = tempUrl.replace('<search-text>', searchText).replace('<search-only-no-service>', (showOnlyClosedServices ? 'true' : 'false'));
    return tempUrl;
}

export const NurseAPIUrl = (companyCode, nurseId = 0) => {
    const nurseAPI = CompanyAPIUrl(companyCode) + CommonUrls.Nurse;
    return nurseAPI + (nurseId > 0 ? ('?nurse_id=' + nurseId.toString()) : '').trim();
}

export const NurseSalaryPaySearchAPIUrl = (companyCode, nurseId) => {
    const nurseAPI = CompanyAPIUrl(companyCode) + CommonUrls.NurseSalaryPaySearch;
    return nurseAPI + '?nurse_id=' + nurseId.toString().trim();
}

export const NurseNursePendingSalaryPayAPIUrl = (companyCode, nurseId) => {
    const nurseAPI = CompanyAPIUrl(companyCode) + CommonUrls.NursePendingSalaryPay;
    return nurseAPI + '?nurse_id=' + nurseId.toString().trim();
}

export const NurseSalaryPaymentAPIUrl = (companyCode, nurseSalaryPayId) => {
    const nurseAPI = CompanyAPIUrl(companyCode) + CommonUrls.NurseSalaryPayment;
    return nurseAPI + (nurseSalaryPayId > 0 ? ('?nurse_salary_pay_id=' + nurseSalaryPayId.toString()) : '').trim();
}

export const NurseAdvancePaySearchAPIUrl = (companyCode, nurseId) => {
    const nurseAPI = CompanyAPIUrl(companyCode) + CommonUrls.NurseAdvancePaySearch;
    return nurseAPI + '?nurse_id=' + nurseId.toString().trim();
}

export const NurseAdvanceReturnPaySearchAPIUrl = (companyCode, nurseId) => {
    const nurseAPI = CompanyAPIUrl(companyCode) + CommonUrls.NurseAdvanceReturnPaySearch;
    return nurseAPI + '?nurse_id=' + nurseId.toString().trim();
}

export const NurseAdvancePayAPIUrl = (companyCode, advancePayId) => {
    const nurseAPI = CompanyAPIUrl(companyCode) + CommonUrls.NurseAdvancePayment;
    return nurseAPI + (advancePayId > 0 ? ('?advance_pay_id=' + advancePayId.toString()) : '').trim();
}

export const NurseAdvanceReturnPayAPIUrl = (companyCode, advanceReturnPayId) => {
    const nurseAPI = CompanyAPIUrl(companyCode) + CommonUrls.NurseAdvanceReturnPayment;
    return nurseAPI + (advanceReturnPayId > 0 ? ('?advance_pay_return_id=' + advanceReturnPayId.toString()) : '').trim();
}

export const NurseVacationTrackerAPIUrl = (companyCode, nurseId) => {
    const nurseAPI = CompanyAPIUrl(companyCode) + CommonUrls.NurseVacationTracker;
    return nurseAPI + (nurseId > 0 ? ('?nurse_id=' + nurseId.toString()) : '').trim();
}

export const NurseServiceBookingSearchAPIUrl = (companyCode, searchText) => {
    const nurseAPI = CompanyAPIUrl(companyCode) + CommonUrls.NurseServiceBookingSearch;
    return nurseAPI + '?search_text=' + searchText.toString().trim();
}

export const NurseServiceBookingAPIUrl = (companyCode, booking_id) => {
    const nurseAPI = CompanyAPIUrl(companyCode) + CommonUrls.NurseServiceBooking;
    return nurseAPI + (booking_id > 0 ? ('?booking_id=' + booking_id.toString()) : '').trim();
}

export const PatientAPIUrl = (companyCode, serviceId = 0, serviceNurseId = 0) => {
    const patientAPI = CompanyAPIUrl(companyCode) + CommonUrls.Patient;
    return patientAPI + (serviceNurseId > 0 ? ('?service_nurse_id=' + serviceNurseId.toString()) : '').trim()
        + (serviceId > 0 ? ('&service_id=' + serviceId.toString()) : '').trim()
}

export const PatientCompleteAPIUrl = (companyCode) => {
    return CompanyAPIUrl(companyCode) + CommonUrls.PatientComplete;
}

export const PatientRenewServiceAPIUrl = (companyCode) => {
    return CompanyAPIUrl(companyCode) + CommonUrls.PatientRenewService;
}

export const PatientNurseChangeAPIUrl = (companyCode) => {
    return CompanyAPIUrl(companyCode) + CommonUrls.PatientNurseChange;
}

export const PatientSearchAPIUrl = (companyCode, searchQuery = '') => {
    const patientAPI = CompanyAPIUrl(companyCode) + CommonUrls.PatientSearch;
    return patientAPI + searchQuery;
}

export const ServicePaymentAPIUrl = (companyCode, serviceId) => {
    const paymentAPI = CompanyAPIUrl(companyCode) + CommonUrls.ServicePayment;
    return paymentAPI.replace('<service_id>', serviceId.toString());
}

export const PatientServicePaymentAPIUrl = (companyCode, paymentId) => {
    const paymentAPI = CompanyAPIUrl(companyCode) + CommonUrls.PatientServicePayment;
    return paymentAPI + (paymentId > 0 ? ('?service_pay_id=' + paymentId.toString()) : '').trim()
}

export const EmployeeSearchAPIUrl = (companyCode, searchText = '') => {
    return CompanyAPIUrl(companyCode) + CommonUrls.USysEmployeeSearch + searchText;
}

export const EmployeeAPIUrl = (companyCode, employeeId = 0) => {
    const tempEmpApi = CompanyAPIUrl(companyCode) + CommonUrls.USysEmployee;
    return tempEmpApi + (employeeId > 0 ? '?employee_id=' + employeeId.toString() : '');
}

export const EmployeeDocumentAPIUrl = (companyCode, employeeId = 0) => {
    const tempEmpApi = CompanyAPIUrl(companyCode) + CommonUrls.USysEmployeeDocument;
    return tempEmpApi + (employeeId > 0 ? '?employee_id=' + employeeId.toString() : '');
}

export const GetDateFromDayJSValue = (dayJSvalue) => dayJSvalue ? dayJSvalue.hour(0).minute(0).second(0).toDate() : null;

export const GetDayJSValueFromUTCDate = (utcDate) => dayjs.utc(utcDate).local().hour(0).minute(0).second(0);

export const GetNumberFromCurrencyFormat = (currencyValue) => {
    let tempValue = currencyValue.toString().replaceAll(',', '');
    tempValue = tempValue.indexOf('.') > -1 ? tempValue.substring(0, tempValue.length - 3) : tempValue;
    return isNaN(parseFloat(tempValue)) ? '' : tempValue.toString();
}

export const GetFormattedNo = (numberValue) => {
    const tempValue = new Intl.NumberFormat('en-IN').format(numberValue.toString().replaceAll(',', ''));
    return isNaN(parseFloat(tempValue)) ? '' : tempValue.toString();
}

export const GetNoToCurrencyFormat = (numberValue) => {
    const tempValue = new Intl.NumberFormat('en-IN').format(numberValue.toString().replaceAll(',', ''));
    if (tempValue.toString().indexOf('.') === -1) {
        return tempValue + '.00';
    } return tempValue;
}

export const GetFullPhoneNo = (phone1, phone2 = '', phone3 = '') => {
    let tempPhone = '';

    if (phone1 && phone1.trim().length > 0) {
        tempPhone = phone1.trim();
    }
    if (phone2 && phone2.trim().length > 0) {
        if (tempPhone.length > 0) {
            tempPhone += ', ';
        }
        tempPhone += phone2.trim();
    }
    if (phone3 && phone3.trim().length > 0) {
        if (tempPhone.length > 0) {
            tempPhone += ', ';
        }
        tempPhone += phone3.trim();
    }
    return tempPhone.trim();
}